import { render, staticRenderFns } from "./MetricCard.vue?vue&type=template&id=3e97091e&"
import script from "./MetricCard.vue?vue&type=script&lang=ts&"
export * from "./MetricCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports